import { Component, Input, ViewChild } from "@angular/core";
import { BonusService } from "src/app/services/bonus/bonus.service";
import { Navigator } from 'src/app/components/menu/navigator';
import { ConfigService } from "src/app/services/config/config.service";
import { SwiperOptions } from "swiper";
import { SwiperComponent } from "swiper/angular";
import { LobbyNavigator } from "src/app/services/lobby/lobby-navigator.service";
import { IPromotion } from "src/app/interfaces/player-dashboard.interface";

@Component({
    selector: 'app-promotions-section',
    templateUrl: './promotions-section.component.html',
    styleUrls: ['./promotions-section.component.scss'],
})
export class PromotionsSectionComponent {
    @Input() set promotionsList (val: Array<IPromotion>) {
        this.promotions = val.filter(this.filteredBanners).map((item) => {
            item.banner_image_large = this.config.getCampaignBanerImgUrl(item).lg;
            item.banner_image_small = this.config.getCampaignBanerImgUrl(item).sm;
            item.banner_image_medium = this.config.getCampaignBanerImgUrl(item).md;

            return item;
        });
    }
    @ViewChild('slides') slides: SwiperComponent;

    public promotions: Array<IPromotion>;
    private autoPlayStopped = false;
    private dragged = false

    public swiperConfig: SwiperOptions = {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        navigation: false,
        pagination: {
            type: 'bullets',
            clickable: true,
        },
        effect: 'slide',
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
    }

    constructor (
        private bonusService: BonusService,
        private navigator: Navigator,
        public config: ConfigService,
        private lobbyNavigator: LobbyNavigator
    ) {}

    private filteredBanners = (banner: IPromotion) => {
        return !!~~banner.show_banner_flag;
    }

    public startAutoPlay() {
        if (this.autoPlayStopped === true && !this.dragged) {
            this.slides.swiperRef.autoplay.start();
            this.autoPlayStopped = false;
        }
    }

    public stoppedAutoplay() {
        this.autoPlayStopped = true;
    }

    public slideDragged() {
        this.dragged = true;
    }

    public moreInfo(promo: IPromotion) {
        this.navigator.openPopover(
            'PromotionDetailsPopoverComponent',
            promo,
            'standard-popover',
            true,
            true,
            true
          );
    }
}